module.exports = __webpack_public_path__ + "media/images/win_matches-4a16218f6b881fa6a80c8fe3438796bd.png";